import './index.css'
import { useState, useEffect } from 'react'
import { fetchFreeTrialDays } from '../../functions/fetchDaysLeftInTrial';

function FreeTrialBanner() {
    const [daysLeft, setDaysLeft] = useState(null);
    const [trialInfoLoaded, setTrialInfoLoaded] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const daysLeftRes = await fetchFreeTrialDays();
                if (!cancelled) {
                    setDaysLeft(daysLeftRes ?? null);
                }
            } finally {
                if (!cancelled) {
                    setTrialInfoLoaded(true);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="trial-banner" role="status" aria-live="polite">
            <div className="trial-banner__accent" aria-hidden />
            <div className="trial-banner__inner">
                <span className="trial-banner__badge">Trial</span>
                <p className="trial-banner__message">
                    {!trialInfoLoaded ? (
                        <span className="trial-banner__lead">Checking your trial status…</span>
                    ) : daysLeft != null && daysLeft !== '' ? (
                        <>
                            <span className="trial-banner__lead">
                                {daysLeft} {Number(daysLeft) === 1 ? 'day' : 'days'} left on your trial.
                            </span>
                            <span className="trial-banner__sub">
                                Add billing to keep full access when it ends.
                            </span>
                        </>
                    ) : (
                        <>
                            <span className="trial-banner__lead">Your trial is active.</span>
                            <span className="trial-banner__sub">
                                Add billing before it ends to avoid losing access.
                            </span>
                        </>
                    )}
                </p>
                <a href="/payment" className="trial-banner__cta">
                    View plans
                </a>
            </div>
        </div>
    );
}

export default FreeTrialBanner
